import PropTypes from "prop-types";

/**
 * Horizontal chat/thread tabs for MolAssist (workspace + drawer).
 * Each thread is a chat tab (not an autonomous agent).
 */
const CopilotAgentTabs = ({
  threads,
  activeThreadId,
  onSelect,
  onNewChat,
  onDeleteThread,
  onClearAll,
  variant = "default",
}) => (
  <div className={`copilot-agent-tabs copilot-agent-tabs--${variant}`}>
    <div className="copilot-agent-tabs__scroll" role="tablist" aria-label="Chat threads">
      {threads.map((t, index) => {
        const active = t.id === activeThreadId;
        const label = t.title && t.title !== "New chat" ? t.title : `Chat ${index + 1}`;
        return (
          <div
            key={t.id}
            className={`copilot-agent-tabs__tab-wrap${active ? " copilot-agent-tabs__tab-wrap--active" : ""}`}
          >
            <button
              type="button"
              role="tab"
              aria-selected={active}
              className={`copilot-agent-tabs__tab${active ? " copilot-agent-tabs__tab--active" : ""}`}
              title={label}
              onClick={() => onSelect(t.id)}
            >
              <i className="pi pi-comments" aria-hidden />
              <span className="copilot-agent-tabs__label">{label}</span>
              {t.module ? (
                <span className="copilot-agent-tabs__module">{t.module}</span>
              ) : null}
            </button>
            {onDeleteThread ? (
              <button
                type="button"
                className="copilot-agent-tabs__close"
                title="Close chat"
                aria-label={`Close ${label}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteThread(t.id);
                }}
              >
                <i className="pi pi-times" aria-hidden />
              </button>
            ) : null}
          </div>
        );
      })}
    </div>
    <div className="copilot-agent-tabs__actions">
      {onClearAll && threads.length > 0 ? (
        <button
          type="button"
          className="copilot-agent-tabs__clear"
          onClick={onClearAll}
          title="Clear all chats"
        >
          <i className="pi pi-trash" aria-hidden />
          <span>Clear all</span>
        </button>
      ) : null}
      <button
        type="button"
        className="copilot-agent-tabs__new"
        onClick={onNewChat}
        title="New chat"
      >
        <i className="pi pi-plus" />
        <span>New chat</span>
      </button>
    </div>
  </div>
);

CopilotAgentTabs.propTypes = {
  threads: PropTypes.array.isRequired,
  activeThreadId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onNewChat: PropTypes.func.isRequired,
  onDeleteThread: PropTypes.func,
  onClearAll: PropTypes.func,
  variant: PropTypes.oneOf(["default", "workspace", "drawer"]),
};

export default CopilotAgentTabs;
